import { CSSProperties } from "react";
import { useTranslation } from "react-i18next";

const translations: { [key: string]: any } = {
  en: {
    title: "Download Houmti app",
    description:
      "Stay up to date with the latest news and offers in your neighborhood wherever you are, download the mobile app and make the most of Houmti",
  },
  fr: {
    title: "Télécharger l'application Houmti",
    description:
      "Restez à jour avec les dernières nouvelles et offres dans votre quartier où que vous soyez, téléchargez l'application mobile et profitez au maximum de Houmti",
  },
  ar: {
    title: "قم بتنزيل تطبيق حومتي",
    description:
      "ابق على اطلاع على آخر الأخبار والعروض في منطقتك أينما كنت ، قم بتنزيل تطبيق الهاتف ، واستفد من حومتي إلى أقصى حد",
  },
};

const getStyles: (rtl: boolean) => { [key: string]: CSSProperties } = (
  rtl
) => ({
  section: {
    display: "flex",
    alignItems: "center",
    overflow: "hidden",
    paddingTop: "24px",
    marginTop: "-40px", // :'(
    textAlign: rtl ? "right" : "left",
  },
  storeButtons: {
    width: "100%",
  },
  mockPhonesContainer: {
    display: "flex",
  },
  mockPhone1: {
    transform: `translate(${rtl ? "-" : ""}40%) rotate(${rtl ? "-" : ""}10deg)`,
  },
  mockPhone2: {
    transform: `translateY(20%) rotate(${rtl ? "-" : ""}10deg)`,
    zIndex: -10000,
  },
});

const DownloadAppSection = () => {
  const { i18n } = useTranslation();
  const lang: string = i18n.language;
  const styles = getStyles(i18n.dir() === "rtl");

  return (
    <section style={styles.section}>
      <div className="container">
        <div className="row">
          <div className="col-md-6 d-flex m-auto align-items-center">
            <div className="mb-4">
              <h2 className="mb-4">{translations[lang].title}</h2>
              <p className="my-2">{translations[lang].description}</p>
              <div className="d-flex my-4 col-sm-6 col-md-10 col-xl-8 p-0">
                <a
                  href="https://play.google.com/store/apps/details?id=com.houmti.mobilecoderz"
                  className="m-1"
                  style={styles.storeButtons}
                >
                  <img
                    src="assets/images/GooglePlayBadge.png"
                    className="img-fluid"
                    alt="banner"
                  />
                </a>
                <a
                  href="https://apps.apple.com/app/id1550251991?fbclid=IwAR1wICV2dwa3w-dSJ3QcdBaJ7pB0pW2yeJ15iw9G_rWGH1ltZ2bIySfWLlc"
                  className="m-1"
                  style={styles.storeButtons}
                >
                  <img
                    src="assets/images/AppStoreBadge.png"
                    className="img-fluid"
                    alt="banner"
                  />
                </a>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div style={styles.mockPhonesContainer}>
              <img
                src="assets/images/screenshot1.png"
                className="img-fluid col-5 col-sm-4 col-md-6"
                alt="banner"
                style={styles.mockPhone1}
              />
              <img
                src="assets/images/screenshot3.png"
                className="img-fluid col-5 col-sm-4 col-md-6"
                alt="banner"
                style={styles.mockPhone2}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DownloadAppSection;
